module.exports = __webpack_public_path__ + "static/media/chevron-bottom.30fd71db.svg";